import Vue from 'vue';
import App from '../../../../App';
import router from './router';
import "babel-polyfill"; // Vue官方明确说明不支持IE8，但是可以兼容IE9及以上，这里是es6语法转换，用于兼容IE9及以上

// 引入ElementUI
import ElementUI from 'element-ui'; // 引入ElementUI
import 'element-ui/lib/theme-chalk/index.css'; // 引入ElementUI css
Vue.use(ElementUI); // 使用ElementUI


// 引入本地配制文件
import biz from '../../../../config/biz.js'; //引入业务配置文件
import global from '../../../../config/global.js'; // 引入配置文件
Vue.prototype.$global = global; // 全局定义配置文件
import cfg from '../../../../../static/config.json'; // 引入配置文件
Vue.prototype.$global.baseUrl = cfg.BASE_URL;



import {post} from './axios'; // 引入封装的网络请求
import axios from 'axios'; // 引入axios
Vue.prototype.$post = post; // 全局定义axios的post方法
Vue.prototype.$axios = axios; // 全局定义axios

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import Vant from 'vant'; // 引入Vant
import "vant/lib/index.css";//引入Vant样式文件
Vue.use(Vant)

import qs from 'qs'; // 引入axios
Vue.prototype.$qs = qs;

// 引入Tinymce富文本编辑器
import tinymce from 'tinymce';
Vue.prototype.$tinymce = tinymce; // 将全局tinymce对象指向给Vue作用域下
import VueTinymce from "@packy-tang/vue-tinymce"
Vue.use(VueTinymce);





Vue.config.productionTip = false; // 设置为false以阻止vue在启动时生成生产提示




// 全局通用公共组件
import '../../view/cmps/cmps.js'

// 枚举自定义组件
import '../../view/Enum/cmps/cmps.js'
// 组织机构自定义组件
import '../../view/Org/cmps/cmps.js'
// 流程管理自定义组件
import '../../view/wf/exec/cmps/cmps.js'
// 消息系统自定义组件
import '../../view/msg/cmps/cmps.js'
// 版本管理自定义组件
import '../../view/version/cmps/cmps.js'
// 交流互动自定义组件
import '../../view/interact/cmps/cmps.js'
// 信息中心自定义组件
import '../../view/news/cmps/cmps.js'


(function () {
  let t = new Date().getMilliseconds();
  axios.get('../../../../static/config.json?t=' + t).then((res) => {
    // 基础地址
    Vue.prototype.$global.baseUrl = res.data.BASE_URL;
    Vue.prototype.$global.timeout = res.data.SERVER_TIMEOUT;
    axios.defaults.baseURL = Vue.prototype.$global.baseUrl;
    new Vue({
      el: '#app',
      router,
      components: {
        App
      },
      template: '<App/>'
    })
  })
})();




// WEBPACK FOOTER //
// ./src/components/base/global/js/base.js